import './styles/global/grids.global.css'
import './styles/global/typography.global.css'
import './styles/global/components.global.css'
import './styles/global/navigation.global.css'
import './styles/page/auth.page.css'

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/auth.context'
import { ProfileProvider } from './context/profile.context'
import { DataProvider } from './context/data.context'
import { OnboardingProvider } from './context/onboarding.context'
import NetWorth from './pages/networth/networth.page'
import Timeline from './pages/timeline/timeline.page'
import FutureWorth from './pages/futureworth/futureworth.page'
import SignInPage from './pages/auth/signin.page'
import OnboardingPage from './pages/onboarding/onboarding.page'
import LogoutPage from './pages/auth/logout.page'
import PocketwatchAssets from './pages/ui-design/ui-design.page'
import PrivateSignInPage from './pages/auth/private-signin.page'
import ProtectedRoute from './components/protected.route'
import PublicRoute from './components/public.route'
function App () {
  return (
    <AuthProvider>
      <ProfileProvider>
      <DataProvider>
      <OnboardingProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/networth" element={ <ProtectedRoute> <NetWorth /> </ProtectedRoute> } />
            <Route path="/timeline" element={ <ProtectedRoute> <Timeline /> </ProtectedRoute> } />
            <Route path="/futureworth" element={ <ProtectedRoute> <FutureWorth /> </ProtectedRoute> } />
            <Route path="/onboarding" element={  <ProtectedRoute> <OnboardingPage /> </ProtectedRoute> } />
            <Route path="/signin" element={ <PublicRoute> <SignInPage /> </PublicRoute> } />
            <Route path="/login" element={<Navigate to="/signin" replace />} />
            <Route path="/signup" element={<Navigate to="/signin" replace />} />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="/ui-design" element={<PocketwatchAssets />} />
            <Route path="/private/signin" element={<PrivateSignInPage />} />
            <Route path="/" element={<Navigate to="/networth" replace />} />
            <Route path="*" element={<Navigate to="/networth" replace />} />
          </Routes>
        </BrowserRouter>
      </OnboardingProvider>
      </DataProvider>
      </ProfileProvider>
    </AuthProvider>
  )
}

export default App
